import { inMobileApp } from "../mobile/MobileApp";
import { isHttpPrefix } from "../common/window";

export const addPrefixForUrl = (url: string) =>
  window.location.origin + (url || "");

/**
 * 在app中打开一个新的webview
 * @param url 跳转地址
 * @param fn 不在app中使用，自定义函数
 */
export const openWebviewInApp = (url: string, fn?: Function | undefined) => {
  // 在app中，打开一个新的webview
  if (inMobileApp()) {
    window.nativeApp.toWinOrderCorfirm(url);
  }
  // 其他地方直接路由跳转。
  else {
    fn && fn();
  }
};

/**
 * 打电话
 * @param phone
 */
export const callPhoneInApp = (phone: string) => {
  // 在app中
  if (inMobileApp()) {
    window.nativeApp.callPhone(phone);
  }
  // 在浏览器中
  else {
    window.location.href = "tel://" + phone;
  }
};

/**
 * 获取app状态栏高度，带有缓存
 */
export const getAppStatusBarHeight: any = () => {
  if (getAppStatusBarHeight.promise) return getAppStatusBarHeight.promise;

  const promise = new Promise(async resolve => {
    const height = +(await window.nativeApp?.getStatusBarHeight()) || 0;
    resolve(height);
  });

  return (getAppStatusBarHeight.promise = promise);
};

/**
 * 获取app底部高度，带有缓存
 */
export const getAppBottomHeight: any = () => {
  if (getAppBottomHeight.promise) return getAppBottomHeight.promise;

  const promise = new Promise(async resolve => {
    const height = +(await window.nativeApp?.getBottomHeight()) || 0;
    resolve(height);
  });

  return (getAppBottomHeight.promise = promise);
};

/**
 * 返回
 */
export const browserBack = function () {
  const prev = this.$route.fullPath;

  if (window.history.length === 1) {
    window.nativeApp?.backToHome();
    this.$router.push("/");
  } else {
    this.$router.go(-1);
  }

  // window.history.length 没有改变的处理方案
  setTimeout(async () => {
    if (prev === this.$route.fullPath) {
      window.nativeApp?.backToHome();
    }
  }, 100);
};

/**
 * 返回app 我的
 */
export const closeCurrentWebView = function () {
  const prev = this.$route.fullPath;

  if (window.history.length === 1) {
    window.nativeApp?.finish();
    this.$router.push("/");
  } else {
    this.$router.go(-1);
  }
  // window.history.length 没有改变的处理方案
  setTimeout(async () => {
    if (prev === this.$route.fullPath) {
      window.nativeApp?.finish();
    }
  }, 100);
};

/**
 * 内部 header 顶部 自适应
 */
export const adaptInsideHeaderInApp = async function ({
  pageSelector = ".view-router",
  headerSelector = ".gt-header",
  barTextColor = "black"
} = {}) {
  // if (inMobileApp()) {
  // if (barTextColor === "black") {
  //   window?.nativeApp?.setStatusBarTextBlack();
  // } else if (barTextColor === "white") {
  //   window?.nativeApp?.setStatusBarTextWhite();
  // }
  // const originHeaderHeight = window.SCREEN_SCALE * 48;
  // const statusBarHeight = await getAppStatusBarHeight();
  // const dom: any = document.querySelector(pageSelector);
  // dom.style.paddingTop = getHeaderRealHeight() + "px";
  // const headerDom: any = document.querySelector(headerSelector);
  // headerDom.style.paddingTop = statusBarHeight + "px";
  // headerDom.style.height = originHeaderHeight + statusBarHeight + "px";
  // }
};

/**
 * 外部 header 顶部 自适应
 */
export const adaptOutsideHeaderInApp = async function ({
  pageSelector = ".view-router",
  headerSelector = ".gt-header",
  headerBg = "#FFF",
  headerPosition = "fixed",
  barTextColor = "black",
  paddingTop = 0
} = {}) {
  // if (inMobileApp()) {
  // if (barTextColor === "black") {
  //   window.nativeApp?.setStatusBarTextBlack();
  // } else if (barTextColor === "white") {
  //   window.nativeApp?.setStatusBarTextWhite();
  // }
  // const originHeaderHeight = window.SCREEN_SCALE * 48;
  // const statusBarHeight = await getAppStatusBarHeight();
  // const dom: any = document.querySelector(pageSelector);
  // dom.style.paddingTop =
  //   paddingTop + statusBarHeight + originHeaderHeight + "px";
  // const headerDom: any = document.querySelector(headerSelector);
  // headerDom.style.paddingTop = statusBarHeight + "px";
  // headerDom.style.position = headerPosition;
  // headerDom.style.backgroundColor = headerBg;
  // headerDom.style.height = originHeaderHeight + statusBarHeight + "px";
  // const headerFixedDom: any = document.querySelector(
  //   `${headerSelector} .van-nav-bar--fixed`
  // );
  // headerFixedDom.style.top = statusBarHeight + "px";
  // }
};

/**
 * 通过app跳转
 * @param url 1. http开头，2.原生页面枚举
 */
export const gotoLinkByApp = (url: string) => {
  if (!url) return false;
  let hasTitle = false;
  let hasStatusBar = true;
  // 全屏展示的页面
  const fullScreenRoute = ["/wt-star-level-center"];
  if (fullScreenRoute.find(o => ~url.indexOf(o))) {
    hasStatusBar = false;
    hasTitle = false;
  }
  console.log(url, hasTitle, hasStatusBar);
  if (inMobileApp()) {
    if (url === "OpenWarrantyCardAppealPage") {
      window.nativeApp.openWarrantyCardAppealPage();
      return;
    }
    window.nativeApp.callWeb(url, hasTitle, hasStatusBar);
  } else {
    if (isHttpPrefix(url) || !url.indexOf("/")) window.location.href = url;
  }
};

/**
 * 返回app home
 */
export const toAppHome = function () {
  window.nativeApp?.backToHome();
};
